import { FieldsetForObject } from 'moet-core';
import withAddressForm from './withAddressForm';

export default withAddressForm(FieldsetForObject);
